<template lang="html">
  <div>
    <b-row>
      <b-col sm="12">
        <b-card>
          <b-row>
            <b-col sm="1"><strong>조회기간</strong></b-col>
            <b-col sm="11">
              <input type="text" class="yearstart" id="start_date_id" value=""> ~
              <input type="text" class="yearend" id="end_date_id" value="">
              <span class="ml-3">※ 2016년도 데이터 부터 존재</span>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col sm="1" class="mt-2"><strong>가입/탈퇴</strong></b-col>
            <b-col sm="11">
              <b-form-group>
                <label class="col-form-label">
                  <b-form-radio-group v-model="queryParams.user_status">
                    <b-form-radio value="Y">가입</b-form-radio>
                    <b-form-radio value="N">탈퇴</b-form-radio>
                  </b-form-radio-group>
                </label>
              </b-form-group>
            </b-col>
          </b-row>
          <hr class="mt-0">
          <b-row>
            <b-col sm="12" style="text-align: center;">
              <b-button variant="primary" style="width: 200px;" v-on:click="searchUserStatistics()">검색</b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>



    <b-row>
      <b-col sm="12">
        <b-card>
          <b-row>
            <b-col sm="12">
              <strong>연도별 월간 가입 수 (연도별 월간 탈퇴 수)</strong>
              <b-col v-if="isLoading_graph" sm="12">
                <div class="text-center loadingbar" style="margin:100px 0 150px 0">
                  <div style="width:200px; height:100px; margin:0 auto; vertical-align:middle">
                    <b-spinner label="Large Spinner" style="vertical-align:middle"></b-spinner>
                    <span style="vertical-align:middle; padding:5px; font-weight:blod; font-size:20px">Loading...</span>
                  </div>
                </div>
              </b-col>

              <div v-show="!isLoading_graph" class="chartdiv" id="chartAAA"></div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-card>
          <b-row>
            <b-col sm="12">

              <b-col v-if="isLoading_list" sm="12">
                <div class="text-center loadingbar" style="margin:100px 0 150px 0">
                  <div style="width:200px; height:100px; margin:0 auto; vertical-align:middle">
                    <b-spinner label="Large Spinner" style="vertical-align:middle"></b-spinner>
                    <span style="vertical-align:middle; padding:5px; font-weight:blod; font-size:20px">Loading...</span>
                  </div>
                </div>
              </b-col>

              <div v-else class="mt-3">
                <b-table
                  outlined
                  :fields="fieldsA"
                  :items="itemsA"
                >
                </b-table>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
const moment = require("moment");
import yearpicker from "../../../custom/yearpicker/yearpicker.js";
import swal from 'sweetalert2';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);


export default {
  data() {
    return {

      isLoading_graph: true,
      isLoading_list: true,

      testa:null,
      queryParams: {
        user_status: 'Y',
        start_date: parseInt(moment().add(-4, 'years').format('YYYY')),
        end_date: parseInt(moment().format('YYYY')),
      },
      dateList:[],
      size:0,
      fieldsB: [
        {
          'date': {
            'label': '연도',
          }
        }, {
          'cnt': {
            'label': 'TOTAL',
            formatter: (value, key, item) => {
              return value.toLocaleString()
            }
          }
        }, {
          'maleCnt': {
            'label': '남자',
            formatter: (value, key, item) => {
              return value.toLocaleString()
            }
          }
        }, {
          'femaleCnt': {
            'label': '여자',
            formatter: (value, key, item) => {
              return value.toLocaleString()
            }
          }
        },
      ],
      itemsB:[],
      fieldsA: [
        {
          'year': {
            'label': '연도',
          }
        }, {
          'total': {
            'label': 'TOTAL',
            formatter: (value, key, item) => {
              return value.toLocaleString()
            }
          }
        }, {
          'month1': {
            'label': '1',
            formatter: (value, key, item) => {
              return value.toLocaleString()
            }
          }
        }, {
          'month2': {
            'label': '2',
            formatter: (value, key, item) => {
              return value.toLocaleString()
            }
          }
        },{
          'month3': {
            'label': '3',
            formatter: (value, key, item) => {
              return value.toLocaleString()
            }
          }
        },{
          'month4': {
            'label': '4',
            formatter: (value, key, item) => {
              return value.toLocaleString()
            }
          }
        },{
          'month5': {
            'label': '5',
            formatter: (value, key, item) => {
              return value.toLocaleString()
            }
          }
        },{
          'month6': {
            'label': '6',
            formatter: (value, key, item) => {
              return value.toLocaleString()
            }
          }
        },{
          'month7': {
            'label': '7',
            formatter: (value, key, item) => {
              return value.toLocaleString()
            }
          }
        },{
          'month8': {
            'label': '8',
            formatter: (value, key, item) => {
              return value.toLocaleString()
            }
          }
        },{
          'month9': {
            'label': '9',
            formatter: (value, key, item) => {
              return value.toLocaleString()
            }
          }
        },{
          'month10': {
            'label': '10',
            formatter: (value, key, item) => {
              return value.toLocaleString()
            }
          }
        },{
          'month11': {
            'label': '11',
            formatter: (value, key, item) => {
              return value.toLocaleString()
            }
          }
        },{
          'month12': {
            'label': '12',
            formatter: (value, key, item) => {
              return value.toLocaleString()
            }
          }
        },
      ],
      itemsA:[]
    }
  },
  mounted: function() {
    var self = this;
    $('.yearstart').yearpicker({
      // Initial Year
      year: self.queryParams.start_date,
    });
    $('.yearend').yearpicker({
      year: self.queryParams.end_date,
    });

    var self = this;
    setTimeout(function(){
      self.searchUserStatistics();
    }, 1300);
  },
  methods: {
    searchUserStatistics() {

      this.queryParams.start_date = document.getElementById("start_date_id").value;
      this.queryParams.end_date  = document.getElementById("end_date_id").value;
      var start = document.getElementById("start_date_id").value;
      var end = document.getElementById("end_date_id").value;
      var cha = end - start;
      if(cha >= 5 || cha <= 0){
        swal.fire({
          type: 'warning',
          title: '조회기간을 다시 선택하세요',
          // text: cha,
          showConfirmButton: false
        })
        return;
      }


      this.isLoading_graph = true;
      this.isLoading_list = true;

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(this.queryParams));

      var data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/statistics/userjoinList?access_token=' + token, data, null)
        .then((result) => {
          this.dateList = [];
          this.size = result.data.length;

          for(var i=0; i<12; i++){
            var joinStatis = {};
            if(this.size >= 1){
              joinStatis.valx = result.data[0][i].date;
              joinStatis.year1 = result.data[0][i].year;
              joinStatis.valy1 = result.data[0][i].cnt;
            }
            if(this.size >= 2){
              joinStatis.valy2 = result.data[1][i].cnt;
              joinStatis.year2 = result.data[1][i].year;
            }
            if(this.size >= 3){
              joinStatis.valy3 = result.data[2][i].cnt;
              joinStatis.year3 = result.data[2][i].year;
            }
            if(this.size >= 4){
              joinStatis.valy4 = result.data[3][i].cnt;
              joinStatis.year4 = result.data[3][i].year;
            }
            if(this.size >= 5){
              joinStatis.valy5 = result.data[4][i].cnt;
              joinStatis.year5 = result.data[4][i].year;
            }
            this.dateList.push(joinStatis);
          }

          this.drawChartA(this.dateList);
      });
      this.$http.post('/api/statistics/userjoinlisttypeb?access_token=' + token, data, null)
        .then((result) => {

          var resultList = [];
          for(var i=0; i<result.data.length; i++){
            var oResult = {};
            oResult.year = result.data[i][0].year;
            oResult.total = result.data[i][0].cnt;
            oResult.month1 = result.data[i][1].cnt;
            oResult.month2 = result.data[i][2].cnt;
            oResult.month3 = result.data[i][3].cnt;
            oResult.month4 = result.data[i][4].cnt;
            oResult.month5 = result.data[i][5].cnt;
            oResult.month6 = result.data[i][6].cnt;
            oResult.month7 = result.data[i][7].cnt;
            oResult.month8 = result.data[i][8].cnt;
            oResult.month9 = result.data[i][9].cnt;
            oResult.month10 = result.data[i][10].cnt;
            oResult.month11 = result.data[i][11].cnt;
            oResult.month12 = result.data[i][12].cnt;
            resultList.push(oResult);
          }
          this.itemsA = resultList;
          this.isLoading_graph = false;
      });
      /*
      this.$http.post('/api/statistics/yeargenderuserjoinlist?access_token=' + token, data, null)
        .then((result) => {
          this.itemsB = result.data;
          this.isLoading_list = false;
      });
      */

/*      this.$http.post('/api/statistics/yeargenderuser?access_token=' + token, data, null)
        .then((result) => {
          var resultList = [];
          var resultM = {};
          resultM.country = "남자";
          resultM.litres = result.data.maleCnt;
          resultList.push(resultM);

          var resultF = {};
          resultF.country = "여자";
          resultF.litres = result.data.femaleCnt;
          resultList.push(resultF);

          this.drawChartB(resultList);
      });*/

      this.$http.post('/api/statistics/yeartotaljoinlist?access_token=' + token, data, null)
        .then((result) => {
          // this.drawChartA(result.data);
          this.isLoading_list = false;
      });
    },
    drawChartA(chartData) {
      // Create chart instance
      console.log(JSON.stringify(chartData));

      let chart = am4core.create("chartAAA", am4charts.XYChart);
      // Increase contrast by taking evey second color
      chart.colors.step = 2;
      // Add data
      chart.data = chartData;
      // Create axes  / dateAxis
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "valx";
      // categoryAxis.renderer.opposite = true;
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

      // Create series
      function createAxisAndSeries(field, name) {
        let series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = field;
        series.dataFields.categoryX = "valx";
        series.strokeWidth = 2;
        series.yAxis = valueAxis;
        series.name = name;
        series.tooltipText = "{name}: [bold]{valueY}[/]";
        series.tensionX = 0.8;
        series.showOnInit = true;

        let interfaceColors = new am4core.InterfaceColorSet();

        var bullet = series.bullets.push(new am4charts.CircleBullet());
        bullet.circle.stroke = interfaceColors.getFor("background");
        bullet.circle.strokeWidth = 2;

        valueAxis.renderer.line.strokeOpacity = 1;
        valueAxis.renderer.line.strokeWidth = 2;
        valueAxis.renderer.line.stroke = series.stroke;
        valueAxis.renderer.labels.template.fill = series.stroke;
        valueAxis.renderer.opposite = false;
      }

      if(this.size >= 1){
        createAxisAndSeries("valy1", chartData[0].year1);
      }
      if(this.size >= 2){
        createAxisAndSeries("valy2", chartData[0].year2);
      }
      if(this.size >= 3){
        createAxisAndSeries("valy3", chartData[0].year3);
      }
      if(this.size >= 4){
        createAxisAndSeries("valy4", chartData[0].year4);
      }
      if(this.size >= 5){
        createAxisAndSeries("valy5", chartData[0].year5);
      }
      // Add legend
      chart.legend = new am4charts.Legend();
      // Add cursor
      chart.cursor = new am4charts.XYCursor();
    },
    drawChartB(chartData){
      // Create chart instance
      var chart = am4core.create("chartBBB", am4charts.PieChart);

      chart.data = chartData;

      // Add and configure Series
      var pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "litres";
      pieSeries.dataFields.category = "country";

      // Let's cut a hole in our Pie chart the size of 30% the radius
      chart.innerRadius = am4core.percent(30);

      // Put a thick white border around each Slice
      pieSeries.slices.template.stroke = am4core.color("#fff");
      pieSeries.slices.template.strokeWidth = 2;
      pieSeries.slices.template.strokeOpacity = 1;
      pieSeries.slices.template
        // change the cursor on hover to make it apparent the object can be interacted with
        .cursorOverStyle = [
          {
            "property": "cursor",
            "value": "pointer"
          }
        ];

      pieSeries.alignLabels = false;
      pieSeries.labels.template.bent = true;
      pieSeries.labels.template.radius = 3;
      pieSeries.labels.template.padding(0,0,0,0);

      pieSeries.ticks.template.disabled = true;

      // Create a base filter effect (as if it's not there) for the hover to return to
      var shadow = pieSeries.slices.template.filters.push(new am4core.DropShadowFilter);
      shadow.opacity = 0;

      // Create hover state
      var hoverState = pieSeries.slices.template.states.getKey("hover"); // normally we have to create the hover state, in this case it already exists

      // Slightly shift the shadow and make it more prominent on hover
      var hoverShadow = hoverState.filters.push(new am4core.DropShadowFilter);
      hoverShadow.opacity = 0.7;
      hoverShadow.blur = 5;

      // Add a legend
      chart.legend = new am4charts.Legend();
    }
  },
  watch: {
    'queryParams.start_date': function() {
      console.log(this.queryParams.start_date);
    },
  },
}
</script>

<style src="../../../custom/yearpicker/yearpicker.css"></style>

<style lang="css" scoped>
#start_date_id {
  text-align:center;
  width:100px;
  border: 1px solid #c2cfd6;
  border-radius: 0;
}
#end_date_id{
  text-align:center;
  width:100px;
  border: 1px solid #c2cfd6;
  border-radius: 0;
}

.chartdiv {
  width: 100%;
  height: 350px;
}
</style>



// WEBPACK FOOTER //
// src/views/statistics/user/UserStatistics.vue